/* Prevent background color leak outs */
export var backgroundClipStyle = "\n  -webkit-background-clip: padding-box; \n  -moz-background-clip:    padding; \n  background-clip:         padding-box;\n";